import dataModel from '../../models/DataModel.js';
import locationsService from '../../services/locationsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const location_root = {
  location: {
    market: {
      
    },
    location_users: {
      user: { },
    },
    users: {},
  },
};

export const locations_nav_root = {
  location: {
  },
};

export default class ProjectLocationsCollection extends AOCollection {
  constructor(name, project_id, userId, companyId, subKey, filter, recordDescriptor) {
    super({
      name: name,
      collectionType: ReduxConstants.LOCATION,
      userId,
      companyId, 
      subKey,
      filter,
      recordDescriptor,
    });
    this._project_id= project_id;
  }

  static build(name, project_id, userId, companyId, subKey, filter, recordDescriptor) {
    const collection = new ProjectLocationsCollection(name, project_id, userId, companyId, subKey, filter, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection.ids = collectionData.ids;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor ? collectionData.recordDescriptor : recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchCurrent(shouldPaginate = true, options = {}) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = locationsService.getProjectLocations.bind(this, this._project_id, null, options);
        let newCollection = await this._fetchData(serviceCall, options);
    
        newCollection.totalLocations = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/ProjectLocationsCollection.js